import { Routes } from '@angular/router';

import { HomePage } from './pages/home.page';
import { ContactsPage } from './pages/contacts.page';
import { ProfilePage } from './pages/profile.page';
import { LoginPage } from './pages/login.page';
import { SetSecurityQuestionsPage } from './pages/set-security-questions.page';
import { SetAuthorizationPinPage } from './pages/set-authorization-pin.page';
import { UnlockAccountPage } from './pages/unlock-account.page';
import { WalletyMePaymentPage } from './pages/walletyme-payment.page';
import { RejectWalletyMeRequestPage } from './pages/walletyme-reject.page';
import { ForgotPinPage } from './pages/forgot-pin.page';
import { LogoutPage } from './pages/logout.page';
import { ViewAccountPage } from './pages/view-account.page';
import { ActivityPage } from './pages/activity.page';
import { RegisterPage } from './pages/register.page';
export const routes: Routes = [

  { path: '', component: HomePage },

  { path: 'contacts', component: ContactsPage },
  { path: 'profile', component: ProfilePage },

  { path: 'Login', component: LoginPage },
  { path: 'Login/:userId', component: LoginPage },

  { path: 'Register', component: RegisterPage },
  { path: 'Register/:number', component: RegisterPage },

   { path: 'Activity/:token', component: ActivityPage },
  { path: 'ViewAccount/:token', component: ViewAccountPage },
  { path: 'Logout/:key', component: LogoutPage },

  { path: 'setsecurityquestions', component: SetSecurityQuestionsPage },
  { path: 'setsecurityquestions/:userId', component: SetSecurityQuestionsPage },

  { path: 'setauthorizationpin', component: SetAuthorizationPinPage },
  { path: 'setauthorizationpin/:userId', component: SetAuthorizationPinPage },

  { path: 'unlockaccount', component: UnlockAccountPage },
  { path: 'unlockaccount/:userId', component: UnlockAccountPage },

  { path: 'forgotpin', component: ForgotPinPage },
  { path: 'forgotpin/:userId', component: ForgotPinPage },

  { path: 'RequestApprove/:requestId', component: WalletyMePaymentPage },

  { path: 'RequestReject/:requestId', component: RejectWalletyMeRequestPage },
  // Put this LAST
  { path: ':userSession', component: LoginPage }
];